import React from 'react';
import { Link } from 'react-router-dom';
import { 
  PhoneIcon, 
  EnvelopeIcon, 
  MapPinIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon
} from '../Icons/SocialIcons';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white pt-12 pb-6">
      <div className="container-custom mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-primary">Teem Wildlife Wonders</h3>
            <p className="mb-4 text-gray-300">
              Established in 2023, Teem Wildlife Wonders is a premier tours and travel agency based in Nairobi, Kenya. 
              Our mission is to provide unforgettable travel experiences that showcase the diverse beauty, rich culture, 
              and vibrant wildlife of Kenya through customized travel itineraries.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" 
                 className="text-gray-300 hover:text-primary transition-colors">
                <FacebookIcon className="h-6 w-6" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" 
                 className="text-gray-300 hover:text-primary transition-colors">
                <InstagramIcon className="h-6 w-6" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" 
                 className="text-gray-300 hover:text-primary transition-colors">
                <TwitterIcon className="h-6 w-6" />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-primary">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/tours" className="text-gray-300 hover:text-primary transition-colors">
                  Tours & Safaris
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-primary transition-colors">
                  Travel Blog
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-primary transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-primary transition-colors">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Tour Categories */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-primary">Tour Categories</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/tours?category=wildlife" className="text-gray-300 hover:text-primary transition-colors">
                  Wildlife Safaris
                </Link>
              </li>
              <li>
                <Link to="/tours?category=beach" className="text-gray-300 hover:text-primary transition-colors">
                  Beach Holidays
                </Link>
              </li>
              <li>
                <Link to="/tours?category=mountain" className="text-gray-300 hover:text-primary transition-colors">
                  Mountain Climbing
                </Link>
              </li>
              <li>
                <Link to="/tours?category=cultural" className="text-gray-300 hover:text-primary transition-colors">
                  Cultural Tours
                </Link>
              </li>
              <li>
                <Link to="/tours?category=adventure" className="text-gray-300 hover:text-primary transition-colors">
                  Adventure Tours
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-primary">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPinIcon className="h-5 w-5 text-primary mr-2 mt-1" />
                <span className="text-gray-300">
                  Karen business center, Karen Road, Nairobi, Kenya
                </span>
              </li>
              <li className="flex items-center">
                <PhoneIcon className="h-5 w-5 text-primary mr-2" />
                <a href="tel:+254720024953" className="text-gray-300 hover:text-primary transition-colors">
                  +254 720 024 953
                </a>
              </li>
              <li className="flex items-center">
                <EnvelopeIcon className="h-5 w-5 text-primary mr-2" />
                <a href="mailto:info@teemwildlife.com" className="text-gray-300 hover:text-primary transition-colors">
                  info@teemwildlife.com
                </a>
              </li>
              <li className="flex items-center">
                <EnvelopeIcon className="h-5 w-5 text-primary mr-2 opacity-0" />
                <a href="mailto:timothy@teemwildlife.com" className="text-gray-300 hover:text-primary transition-colors">
                  timothy@teemwildlife.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Divider */}
        <hr className="border-gray-700 my-8" />
        
        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; {currentYear} Teem Wildlife Wonders & Travel. All rights reserved.
          </p>
          <div className="flex space-x-4 text-sm text-gray-400">
            <Link to="/terms" className="hover:text-primary transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/cookies" className="hover:text-primary transition-colors">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
